import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { InputProps } from "../../interfaces/interfaces";

const Input: FunctionComponent<InputProps> = ({
  type,
  name,
  id,
  value,
  placeholder,
  onChange,
  className,
  required
}) => {
  const placeholder_ = `${placeholder}${required?'*':''}`;
  return (
    <StyledInputWrapper className={className} required={required}>
      <input
        required={required}
        type={type}
        name={name}
        id={id}
        value={value}
        placeholder={placeholder_}
        onChange={onChange}
      />
    </StyledInputWrapper>
  );
};

const StyledInputWrapper = styled.div`
  position: relative;

  input {
    font-size: 16px;
    display: block;
    width: calc(100% - 10px);
    height: 30px;
    color: black;
    outline: none;
    border-radius: 4px;
    border: none;
    background-color: #f0f0f0;
    transition: 0.2s all;
    padding: 5px 0px 5px 10px;
  }

  input::-webkit-input-placeholder,
  input::-moz-placeholder,
  input:-ms-input-placeholder,
  input:-moz-placeholder
  input::placeholder {
    color: #9e9e9e;
  }

  input:hover {
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  }
  input:focus {
    color: #e71319;
    border-left: 10px solid #e71319;
  }
`;

export default Input;
